import { DateTime } from 'luxon';

import { END_OF_DAY, START_OF_DAY } from './constants';

export type ChartPoint = {
  time: number;
  value: number;
};

export const groupByDay = (
  from: number,
  to: number,
  data: Record<string, string[]>
) => {
  const mappedData = [] as ChartPoint[];
  let current = DateTime.fromMillis(from).set(START_OF_DAY);
  const maxMillis = DateTime.fromMillis(to).set(END_OF_DAY).toMillis();

  while (current.toMillis() < maxMillis) {
    const currDayData = data[current.toFormat('yyyy-MM-dd')] || [];
    const count = currDayData.length;

    mappedData.push({ time: current.toMillis(), value: count });
    current = current.plus({ day: 1 });
  }

  return mappedData;
};

export const groupByHour = (
  from: number,
  to: number,
  data: Record<string, string[]>
) => {
  const mappedData = [] as ChartPoint[];
  let current = DateTime.fromMillis(from).set(START_OF_DAY);
  const maxMillis = DateTime.fromMillis(to).set(END_OF_DAY).toMillis();

  while (current.toMillis() < maxMillis) {
    const currDayData = data[current.toFormat('yyyy-MM-dd')] || [];
    const count = currDayData.filter(
      (value) => DateTime.fromISO(value).hour === current.hour
    ).length;

    mappedData.push({ time: current.toMillis(), value: count });
    current = current.plus({ hour: 1 });
  }

  return mappedData;
};
